import { useNavigate } from "react-router-dom";
import Et3Button from "../../core/et3-button";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreLoginStore from "../../stores/core/core-login-store";

const SignInButton = withLiteObserverAndTheme(() => {
  const disabledButton = getCoreLoginStore().isSignInDisabled.get();
  const navigate = useNavigate();

  return (
    <Et3Button
      onClick={() => {
        getCoreLoginStore().signIn();
        navigate({ pathname: "/" });
      }}
      isEnabled={!disabledButton}
      type="GET"
      size="LARGE"
      text="SIGN_IN"
    />
  );
});
export default SignInButton;
